import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import strings from 'localization/strings';
import { useDispatch } from 'react-redux';
import { handleResponse } from 'actions/actionHelpers';
import { fetchIloqRealEstates } from 'actions/iloq';
import { required } from 'form/validation';

import { TextField, showErrorOnBlur } from 'mui-rff';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';

const IloqStorageSiteLockConfigurationEditor = ({ fieldNamePrefix }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [realEstates, setRealEstates] = useState(undefined);

    useEffect(() => {
        let mounted = true;
        dispatch(fetchIloqRealEstates())
            .then(handleResponse(
                response => {
                    if(mounted) {
                        setRealEstates(response.payload);
                        setIsLoading(false);
                    }
                },
                () => {
                    if(mounted) {
                        setIsLoading(false);
                    }
                }
            ));
        return () => {
            mounted = false;
        };
    }, []);

    const getName = suffix => suffix ? `${fieldNamePrefix}.${suffix}` : fieldNamePrefix;

    if(isLoading) {
        return (
            <CircularProgress
                size={16}
                color="primary"
            />
        );
    }

    return (
        <TextField
            select
            label={strings.iloqRealEstate}
            name={getName('realEstateId')}
            variant="outlined"
            showError={showErrorOnBlur}
            required
            fieldProps={{ validate: required }}
        >
            {
                realEstates.map(o => (
                    <MenuItem key={o.id} value={o.id}>
                        {o.name}
                    </MenuItem>
                ))
            }
        </TextField>
    );
};

IloqStorageSiteLockConfigurationEditor.propTypes = {
    fieldNamePrefix: PropTypes.string.isRequired
};

export default IloqStorageSiteLockConfigurationEditor;
